import { render, staticRenderFns } from "./yearList.vue?vue&type=template&id=74847a8e&scoped=true&"
import script from "./yearList.vue?vue&type=script&lang=js&"
export * from "./yearList.vue?vue&type=script&lang=js&"
import style0 from "./yearList.vue?vue&type=style&index=0&id=74847a8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74847a8e",
  null
  
)

export default component.exports